import { initGlobal } from '@js/_common.ts'

initGlobal()
